module.exports = __webpack_public_path__ + "media/images/search-icon-21dfa355b6230e5a229eb32d54c114b3.png";